// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class MediaBannerProductsCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    this.addEventListener('klevuProductsLoaded', this.reinitCarousel.bind(this))
  }

  reinitCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = this.initialiseCarousel()
    }

    super.reinitialise()
  }

  get numberOfSlides () {
    return this.els?.slide.elements.length
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return

    if (window.innerWidth > 1000) {
      return new KeenSlider(this.els.slides.element, {
        selector: this.els.slide.selector,
        drag: true,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          origin: 'center',
          perView: 4,
          spacing: 18,
        },
      })
    }
  }
}

if (!customElements.get('media-banner-products-carousel')) {
  customElements.define(
    'media-banner-products-carousel',
    MediaBannerProductsCarousel,
  )
}
